module.exports = __webpack_public_path__ + "static/assets/e068809bad5b36df209c78f213ebe958.png";